import AppContext from "common-components/dist/common/components/App/context";

export default AppContext;
